import { render, staticRenderFns } from "./payment-page-create.vue?vue&type=template&id=4b6d2af9&scoped=true&"
import script from "./payment-page-create.vue?vue&type=script&lang=js&"
export * from "./payment-page-create.vue?vue&type=script&lang=js&"
import style0 from "./payment-page-create.vue?vue&type=style&index=0&id=4b6d2af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d2af9",
  null
  
)

export default component.exports